export const SidebarToggleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#000000"
      stroke-width="1.35"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="3" y="4" width="18" height="16" rx="2"></rect>
      <line x1="9" y1="4" x2="9" y2="20"></line>
    </svg>
  );
};
